const NAVY = "#123B5D";
const MUTED = "#5B6B7A";
const FILL = "#F3F6FA";
const FILL_HOVER = "#EDF1F6";
const FILL_DISABLED = "#E9EEF3";
const BORDER = "#DCE4EC";

export const profileCss = `
.ep-page { width: 100%; max-width: 100%; margin: 0 auto; padding: 16px; box-sizing: border-box; color: #1B2733; }

/* ---------- hero ---------- */
.ep-hero {
  display: flex; align-items: center; flex-wrap: wrap; gap: 16px;
  padding: 16px 20px; border-radius: 14px;
  background: linear-gradient(120deg, #EAF2FB 0%, #F8FBFE 75%);
  border: 1px solid ${BORDER};
}
.ep-avatar {
  width: 64px; height: 64px; flex-shrink: 0; border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  background: ${NAVY}; color: #fff; font-size: 20px; font-weight: 700; letter-spacing: 1px;
  box-shadow: 0 0 0 3px #fff, 0 0 0 4px #C9D8E8;
}
.ep-hero-main { flex: 1; min-width: 220px; }
.ep-hero-top { display: flex; align-items: center; flex-wrap: wrap; gap: 8px; }
.ep-hero-name { margin: 0; font-size: 19px; font-weight: 700; line-height: 1.25; color: ${NAVY}; }
.ep-hero-meta { display: flex; flex-wrap: wrap; gap: 8px; margin-top: 8px; }
.ep-pill {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 3px 10px; border-radius: 7px;
  background: #E3EBF3; color: #33485C; font-size: 12px; font-weight: 600;
}
.ep-hero-contact { display: flex; flex-direction: column; gap: 6px; font-size: 13px; color: #33485C; }
.ep-hero-contact span { display: inline-flex; align-items: center; gap: 8px; }
.ep-chip-icon {
  width: 30px; height: 30px; flex-shrink: 0; border-radius: 9px;
  display: inline-flex; align-items: center; justify-content: center;
  background: #E3ECF6; color: ${NAVY}; font-style: normal;
}

/* ---------- badges ---------- */
.ep-badge { display: inline-block; padding: 2px 9px; border-radius: 7px; font-size: 11.5px; font-weight: 700; }
.ep-badge-active { background: #DFF4E7; color: #167A43; }
.ep-badge-temp { background: #FFF1D6; color: #96620B; margin-left: 8px; }

/* ---------- pill tabs ---------- */
.ep-tabs { display: inline-flex; gap: 4px; padding: 4px; margin: 14px 0; border-radius: 11px; background: #E6EDF4; }
.ep-tab {
  display: inline-flex; align-items: center; gap: 7px;
  height: 34px; padding: 0 16px; border: 0; border-radius: 8px;
  background: transparent; color: #4A5A69; font-size: 13.5px; font-weight: 600; cursor: pointer;
  font-family: inherit; transition: background-color .15s, color .15s;
}
.ep-tab:hover { color: ${NAVY}; }
.ep-tab.is-active { background: #fff; color: ${NAVY}; box-shadow: 0 1px 3px rgba(18,59,93,0.16); }
.ep-tab:focus-visible { outline: 2px solid ${NAVY}; outline-offset: 2px; }

/* ---------- panel + sections ---------- */
.ep-panel { background: #fff; border: 1px solid ${BORDER}; border-radius: 14px; padding: 20px; }
.ep-section { width: 100%; }
.ep-section-head {
  display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 12px;
  padding-bottom: 14px; margin-bottom: 18px; border-bottom: 1px solid #EEF2F6;
}
.ep-section-title { display: flex; align-items: center; gap: 12px; }
.ep-section-title h3 { margin: 0; font-size: 16px; font-weight: 700; color: ${NAVY}; }
.ep-section-title p { margin: 2px 0 0; font-size: 12.5px; color: ${MUTED}; }
.ep-section-body { width: 100%; }
.ep-section-foot, .ep-footer-wide { margin-top: 20px; }
.ep-sub-head { margin: 22px 0 14px; padding-top: 18px; border-top: 1px solid #EEF2F6; font-size: 13px; font-weight: 700; color: ${NAVY}; }
.ep-gap { height: 6px; }

/* ---------- grid ---------- */
.ep-grid { display: grid; grid-template-columns: repeat(12, 1fr); gap: 16px 18px; }
.ep-c12 { grid-column: span 12; }
.ep-c6 { grid-column: span 6; }
.ep-c4 { grid-column: span 4; }
.ep-c3 { grid-column: span 3; }
.ep-field { min-width: 0; }
.ep-label { display: block; margin-bottom: 6px; font-size: 12.5px; font-weight: 600; color: #33485C; }
.ep-req { margin-left: 3px; color: #D64545; }
.ep-error { display: block; margin-top: 5px; font-size: 11.5px; font-weight: 500; line-height: 1.35; color: #D64545; }

/* ---------- inputs (filled style) ---------- */
.ep-input-wrap { position: relative; width: 100%; }
.ep-input {
  width: 100%; height: 40px; box-sizing: border-box; padding: 0 12px;
  border: 1px solid transparent; border-radius: 8px; background: ${FILL};
  color: #1B2733; font-family: inherit; font-size: 13.5px;
  transition: background-color .15s, border-color .15s, box-shadow .15s;
}
.ep-input::placeholder { color: #8A97A5; opacity: 1; }
.ep-input:hover { background: ${FILL_HOVER}; }
.ep-input:focus { outline: none; background: #fff; border-color: ${NAVY}; box-shadow: 0 0 0 3px rgba(18,59,93,0.12); }
.ep-input:disabled, .ep-input[readonly] { background: ${FILL_DISABLED}; color: ${MUTED}; cursor: not-allowed; }
.ep-input[readonly]:focus { background: ${FILL_DISABLED}; border-color: transparent; box-shadow: none; }
.ep-input.has-ico { padding-left: 38px; }
.ep-input.has-ico-r { padding-right: 40px; }
.ep-input[type="number"] { -moz-appearance: textfield; }
.ep-input[type="number"]::-webkit-outer-spin-button,
.ep-input[type="number"]::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0; }
.ep-ico-left, .ep-ico-right {
  position: absolute; top: 50%; transform: translateY(-50%);
  display: flex; color: #8A97A5; pointer-events: none;
}
.ep-ico-left { left: 13px; }
.ep-ico-right { right: 13px; }
.ep-eye {
  position: absolute; right: 5px; top: 50%; transform: translateY(-50%);
  width: 32px; height: 32px; border: 0; border-radius: 8px; background: transparent;
  display: flex; align-items: center; justify-content: center; color: #8A97A5; cursor: pointer;
}
.ep-eye:hover { color: ${NAVY}; background: rgba(18,59,93,0.07); }
.ep-pin-row { display: flex; gap: 8px; align-items: stretch; }
.ep-pin-row .ep-input-wrap { flex: 1; }

/* ---------- buttons ---------- */
.ep-btn {
  display: inline-flex; align-items: center; justify-content: center; gap: 7px;
  height: 40px; padding: 0 18px; border: 1px solid transparent; border-radius: 8px;
  font-family: inherit; font-size: 13.5px; font-weight: 600; cursor: pointer;
  transition: background-color .15s, border-color .15s, opacity .15s;
}
.ep-btn:disabled { opacity: .55; cursor: not-allowed; }
.ep-btn-primary { background: ${NAVY}; color: #fff; }
.ep-btn-primary:hover:not(:disabled) { background: #0E2F4A; }
.ep-btn-green { background: #2E9E6B; color: #fff; }
.ep-btn-green:hover:not(:disabled) { background: #278A5C; }
.ep-btn-outline { background: #fff; color: ${NAVY}; border-color: #C9D3DD; }
.ep-btn-outline:hover:not(:disabled) { background: #F1F5F9; }
.ep-btn-ghost { background: transparent; color: ${MUTED}; border-color: #C9D3DD; }
.ep-btn-ghost:hover:not(:disabled) { background: #F1F5F9; }
.ep-section-foot .ep-btn, .ep-footer-wide .ep-btn { width: 100%; }
.ep-form-actions { grid-column: span 12; display: flex; justify-content: flex-end; gap: 8px; margin-top: 4px; }

/* ---------- contact cards ---------- */
.ep-contact-list { display: grid; grid-template-columns: repeat(auto-fill, minmax(300px, 1fr)); gap: 14px; }
.ep-card { padding: 14px 16px; border: 1px solid #E3EAF1; border-radius: 12px; background: #fff; }
.ep-card-head { display: flex; align-items: center; gap: 12px; margin-bottom: 12px; }
.ep-card-ico { width: 38px; height: 38px; flex-shrink: 0; border-radius: 10px; display: flex; align-items: center; justify-content: center; background: #E3ECF6; color: ${NAVY}; }
.ep-card-ico.is-office { background: #FFF1D6; color: #96620B; }
.ep-card-title { flex: 1; min-width: 0; font-size: 14px; font-weight: 700; color: ${NAVY}; }
.ep-card-actions { display: flex; gap: 4px; }
.ep-icon-btn { width: 30px; height: 30px; border: 0; border-radius: 8px; background: transparent; color: ${MUTED}; display: flex; align-items: center; justify-content: center; cursor: pointer; }
.ep-icon-btn:hover:not(:disabled) { background: #EEF3F8; color: ${NAVY}; }
.ep-icon-btn.is-danger:hover:not(:disabled) { background: #FDECEC; color: #C62828; }
.ep-icon-btn:disabled { opacity: .5; cursor: not-allowed; }
.ep-card-row { display: flex; align-items: flex-start; gap: 10px; margin-top: 8px; font-size: 13px; line-height: 1.5; color: #33485C; }
.ep-card-row svg { flex-shrink: 0; margin-top: 4px; color: #8A97A5; }
.ep-empty { padding: 22px; text-align: center; border: 1px dashed #C9D3DD; border-radius: 12px; background: #FAFCFE; font-size: 13.5px; color: ${MUTED}; }

/* ---------- responsive ---------- */
@media (max-width: 900px) {
  .ep-c3 { grid-column: span 6; }
  .ep-c4 { grid-column: span 12; }
}
@media (max-width: 640px) {
  .ep-page { padding: 10px; }
  .ep-panel { padding: 14px; }
  .ep-c6, .ep-c3 { grid-column: span 12; }
  .ep-tabs { display: flex; }
  .ep-tab { flex: 1; justify-content: center; padding: 0 8px; }
  .ep-hero-contact { width: 100%; }
}
`;

/* react-select: same filled look as .ep-input */
export const selectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: 40,
    borderRadius: 8,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: state.isFocused ? NAVY : "transparent",
    backgroundColor: state.isFocused ? "#fff" : FILL,
    boxShadow: state.isFocused ? "0 0 0 3px rgba(18,59,93,0.12)" : "none",
    cursor: "pointer",
    "&:hover": {
      borderColor: state.isFocused ? NAVY : "transparent",
      backgroundColor: state.isFocused ? "#fff" : FILL_HOVER,
    },
  }),
  valueContainer: (base) => ({ ...base, padding: "0 12px" }),
  placeholder: (base) => ({
    ...base,
    margin: 0,
    color: "#8A97A5",
    fontSize: 13.5,
  }),
  singleValue: (base) => ({
    ...base,
    margin: 0,
    color: "#1B2733",
    fontSize: 13.5,
  }),
  input: (base) => ({ ...base, margin: 0, padding: 0, fontSize: 13.5 }),
  indicatorSeparator: () => ({ display: "none" }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: 8,
    color: "#8A97A5",
    "&:hover": { color: NAVY },
  }),
  clearIndicator: (base) => ({
    ...base,
    padding: 8,
    color: "#A6B0BA",
    "&:hover": { color: "#687684" },
  }),
  menu: (base) => ({
    ...base,
    zIndex: 9999,
    marginTop: 4,
    borderRadius: 10,
    overflow: "hidden",
    border: `1px solid ${BORDER}`,
    boxShadow: "0 10px 24px rgba(15,35,55,0.14)",
  }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  option: (base, state) => ({
    ...base,
    padding: "9px 12px",
    fontSize: 13.5,
    cursor: "pointer",
    color: state.isSelected ? NAVY : "#1B2733",
    fontWeight: state.isSelected ? 600 : 400,
    backgroundColor: state.isSelected
      ? "#EAF2FB"
      : state.isFocused
        ? "#F4F8FB"
        : "#fff",
  }),
};
